
<!--
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-01 19:09:52
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-08 11:57:13
 * ---上传审核弹框---
-->
<template>
  <div class="review-upload-popup">
    <!-- 地址确认弹框 -->
    <van-popup v-model="show" class="x-van-popup" :close-on-click-overlay="false">
      <div class="upload-popup-top">
        <img src="../assets/images/v4.0/review-popup-title-bg.png" alt="img">
        <span class="upload-popup-top-title">第 {{uploadStatus.current_week}} 周 {{uploadStatus.strWeekStart}}-{{uploadStatus.strWeekEnd}}</span>
      </div>
      <div class="review-upload-popup-close" @click="closePopup()"></div>
      <review-upload :isAlert='true' :uploadStatusForReview='uploadStatusForReview'></review-upload>
    </van-popup>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import ReviewUpload from '../components/ReviewUpload' // 审核上传

export default {
  name: 'ReviewUploadAlert',
  computed: mapState(['uploadStatus']),
  components: { ReviewUpload },
  data () {
    return {
      show: false
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: undefined
    },
    uploadStatusForReview: {
      type: Object,
      default: undefined
    }
  },
  watch: {
    isShow (val) {
      this.show = val
    },
    show (val) {
      console.log('show----', val)
      if (!val) {
        // this.$emit('closePopup')
      }
    }
  },
  methods: {
    // 关闭弹框
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style lang="less" scoped>

.review-upload-popup {
  width: 100%;
  height: 100%;

  .x-van-popup {
    width: 80%;
    padding-bottom: 20px;
    overflow: visible;
    border: 2px solid #ca8e30;
    border-radius: 5px;

    .upload-popup-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 10px;
      margin-bottom: 35px;

      .upload-popup-top-title {
        z-index: 20;
        width: 80%;
        height: 20px;
        font-size: 15px;
        color: #6b4000;
        transform: translateY(-50px);
      }

      img {
        width: 80%;
        height: auto;
        transform: translateY(-15px);
      }
    }

    .review-upload-popup-close {
      position: absolute;
      top: 10px;
      right: 8px;
      width: 20px;
      height: 20px;
      background: url('../assets/images/v4.0/close-yellow.png') no-repeat;
      background-size: 100%;
    }
  }
}
</style>
